import { faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from '../../../files/system/logo.png';
import axios from "axios";
import { Navigate } from "react-router-dom";
import { useState } from "react";
import ErrorAdd from "../../../util/ErrorAdd";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function Header({ fixed }) {

  const [loginLoading, setLoginLoading] = useState(false);

  function login() {
    setLoginLoading(true);

    axios.get('/api_main/user/get')
      .then((res) => {
        if (res.data.ID_Status === 0) {
          return window.location.replace(process.env.REACT_APP_DOMAIN_MAIN + '/login?srv=' + process.env.REACT_APP_ID_SERVICE);
        }
        if (res.data.ID_Status === -1) {
          return <Navigate to="/lk/user_blocked" replace />
        }
        return window.location.replace('/lk');
      })
      .catch((err) => {
        ErrorAdd(err, window.location.href);
        setLoginLoading(false);
        return window.location.replace(process.env.REACT_APP_DOMAIN_MAIN + '/login?srv=' + process.env.REACT_APP_ID_SERVICE);
      });
  }

  return (
    <>
      <div className={fixed === true ? "srv_header fixed" : "srv_header"}>
        <div className="logo"><img src={logo} className='logo'></img></div>
        <div className="right">
          <a href="/login" className={loginLoading === true ? "btn_auth loading" : "btn_auth"} onClick={(e) => { e.preventDefault(); login() }}><i className="icon">
            <FontAwesomeIcon icon={loginLoading === true ? faSpinner : faUser} /></i>
            Вход/регистрация
          </a>
        </div>
      </div>
    </>
  );
}

export default Header;
